import styles from './styles.mod.scss';
import React from 'react';
import classnames from 'classnames';

function LoadingSpinner({ className, green, black, orange, backdrop }) {
  return (
    <div
      className={classnames(styles.outerContainer, {
        [styles.outerContainerBg]: backdrop
      })}
    >
      <div className={styles.innerContainer}>
        <div
          className={classnames(
            styles.spinner,
            {
              [styles.green]: green,
              [styles.black]: black,
              [styles.orange]: orange
            },
            className
          )}
        >
          Loading...
        </div>
      </div>
    </div>
  );
}

export default LoadingSpinner;
